
// You can write more code here

/* START OF COMPILED CODE */

import ChunkBase from "../../ChunkBase";
import ChunkBoundaries from "../../../components/ChunkBoundaries";
import BoundsMarker from "../../editor/BoundsMarker";
import PlatformMarkerJungleLogLong from "../../editor/platform-markers/jungle/PlatformMarkerJungleLogLong";
import DecorationFloatingPoleLong from "../../decorations/shipwreck/DecorationFloatingPoleLong";
import SmashableMarkerCrate from "../../editor/entity-markers/SmashableMarkerCrate";
import SimpleBreakableBlocker from "../../../components/platformer/SimpleBreakableBlocker";
import PlatformMarkerJungleLog from "../../editor/platform-markers/jungle/PlatformMarkerJungleLog";
import DecorationHelpSwitch from "../../decorations/shipwreck/DecorationHelpSwitch";
import DecorationHelpJump from "../../decorations/shipwreck/DecorationHelpJump";
import DecorationHelpJumpDesk from "../../decorations/shipwreck/DecorationHelpJumpDesk";
import DecorationHelpSwitchDesk from "../../decorations/shipwreck/DecorationHelpSwitchDesk";
import SmallGemMarker from "../../editor/entity-markers/SmallGemMarker";
import CheckpointMarker from "../../editor/CheckpointMarker";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class ShipwreckOnboardingChunk extends ChunkBase {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 465, y ?? 369);

    // editor_bounds_left
    const editor_bounds_left = new BoundsMarker(scene, 745, 300);
    this.add(editor_bounds_left);

    // editor_bounds_right
    const editor_bounds_right = new BoundsMarker(scene, 8978, 311);
    this.add(editor_bounds_right);

    // platformMarkerLogLong_1
    const platformMarkerLogLong_1 = new PlatformMarkerJungleLogLong(scene, 1248, 50);
    this.add(platformMarkerLogLong_1);

    // decorationFloatingPoleLong_3
    const decorationFloatingPoleLong_3 = new DecorationFloatingPoleLong(scene, 944, 183);
    this.add(decorationFloatingPoleLong_3);

    // decorationFloatingPoleLong_4
    const decorationFloatingPoleLong_4 = new DecorationFloatingPoleLong(scene, 1266, 183);
    this.add(decorationFloatingPoleLong_4);

    // decorationFloatingPoleLong_5
    const decorationFloatingPoleLong_5 = new DecorationFloatingPoleLong(scene, 1562, 183);
    this.add(decorationFloatingPoleLong_5);

    // crateMarker
    const crateMarker = new SmashableMarkerCrate(scene, 5718, -93);
    this.add(crateMarker);

    // platformLog_3
    const platformLog_3 = new PlatformMarkerJungleLog(scene, 5841, -243);
    this.add(platformLog_3);

    // platformMarkerLogLong_2
    const platformMarkerLogLong_2 = new PlatformMarkerJungleLogLong(scene, 4454, 53);
    this.add(platformMarkerLogLong_2);

    // decorationFloatingPoleLong_6
    const decorationFloatingPoleLong_6 = new DecorationFloatingPoleLong(scene, 4176, 186);
    this.add(decorationFloatingPoleLong_6);

    // decorationFloatingPoleLong_7
    const decorationFloatingPoleLong_7 = new DecorationFloatingPoleLong(scene, 4487, 186);
    this.add(decorationFloatingPoleLong_7);

    // decorationFloatingPoleLong_8
    const decorationFloatingPoleLong_8 = new DecorationFloatingPoleLong(scene, 4759, 186);
    this.add(decorationFloatingPoleLong_8);

    // decorationHelpSwitch
    const decorationHelpSwitch = new DecorationHelpSwitch(scene, 5027, -321);
    this.add(decorationHelpSwitch);

    // decorationHelpJump
    const decorationHelpJump = new DecorationHelpJump(scene, 1317, -324, 'game-all', "help-jump.png");
    this.add(decorationHelpJump);

    // decorationHelpJumpDesk
    const decorationHelpJumpDesk = new DecorationHelpJumpDesk(scene, 1394, -276);
    this.add(decorationHelpJumpDesk);

    // decorationHelpSwitchDesk
    const decorationHelpSwitchDesk = new DecorationHelpSwitchDesk(scene, 5112, -282);
    this.add(decorationHelpSwitchDesk);

    // gemMarker_2
    const gemMarker_2 = new SmallGemMarker(scene, 1625, -199);
    this.add(gemMarker_2);

    // gemMarker_3
    const gemMarker_3 = new SmallGemMarker(scene, 2660, -200);
    this.add(gemMarker_3);

    // decorationFloatingPoleLong_9
    const decorationFloatingPoleLong_9 = new DecorationFloatingPoleLong(scene, 5434, 186);
    this.add(decorationFloatingPoleLong_9);

    // decorationFloatingPoleLong_10
    const decorationFloatingPoleLong_10 = new DecorationFloatingPoleLong(scene, 5706, 186);
    this.add(decorationFloatingPoleLong_10);

    // platformMarkerLogLong_3
    const platformMarkerLogLong_3 = new PlatformMarkerJungleLogLong(scene, 5401, 53);
    this.add(platformMarkerLogLong_3);

    // decorationFloatingPoleLong_11
    const decorationFloatingPoleLong_11 = new DecorationFloatingPoleLong(scene, 5123, 186);
    this.add(decorationFloatingPoleLong_11);

    // platformMarkerLogLong_4
    const platformMarkerLogLong_4 = new PlatformMarkerJungleLogLong(scene, 6347, 53);
    this.add(platformMarkerLogLong_4);

    // decorationFloatingPoleLong_12
    const decorationFloatingPoleLong_12 = new DecorationFloatingPoleLong(scene, 6043, 186);
    this.add(decorationFloatingPoleLong_12);

    // decorationFloatingPoleLong_13
    const decorationFloatingPoleLong_13 = new DecorationFloatingPoleLong(scene, 6365, 186);
    this.add(decorationFloatingPoleLong_13);

    // decorationFloatingPoleLong_14
    const decorationFloatingPoleLong_14 = new DecorationFloatingPoleLong(scene, 6661, 186);
    this.add(decorationFloatingPoleLong_14);

    // platformMarkerLogLong_5
    const platformMarkerLogLong_5 = new PlatformMarkerJungleLogLong(scene, 7291, 53);
    this.add(platformMarkerLogLong_5);

    // decorationFloatingPoleLong_15
    const decorationFloatingPoleLong_15 = new DecorationFloatingPoleLong(scene, 7013, 186);
    this.add(decorationFloatingPoleLong_15);

    // decorationFloatingPoleLong_16
    const decorationFloatingPoleLong_16 = new DecorationFloatingPoleLong(scene, 7324, 186);
    this.add(decorationFloatingPoleLong_16);

    // decorationFloatingPoleLong_17
    const decorationFloatingPoleLong_17 = new DecorationFloatingPoleLong(scene, 7596, 186);
    this.add(decorationFloatingPoleLong_17);

    // decorationFloatingPoleLong_18
    const decorationFloatingPoleLong_18 = new DecorationFloatingPoleLong(scene, 7956, 186);
    this.add(decorationFloatingPoleLong_18);

    // decorationFloatingPoleLong_19
    const decorationFloatingPoleLong_19 = new DecorationFloatingPoleLong(scene, 8267, 186);
    this.add(decorationFloatingPoleLong_19);

    // decorationFloatingPoleLong_20
    const decorationFloatingPoleLong_20 = new DecorationFloatingPoleLong(scene, 8539, 186);
    this.add(decorationFloatingPoleLong_20);

    // platformMarkerLogLong_6
    const platformMarkerLogLong_6 = new PlatformMarkerJungleLogLong(scene, 8234, 53);
    this.add(platformMarkerLogLong_6);

    // gemMarker_4
    const gemMarker_4 = new SmallGemMarker(scene, 3723, -210);
    this.add(gemMarker_4);

    // crateMarker_1
    const crateMarker_1 = new SmashableMarkerCrate(scene, 6656, -93);
    this.add(crateMarker_1);

    // platformLog
    const platformLog = new PlatformMarkerJungleLog(scene, 6779, -242);
    this.add(platformLog);

    // crateMarker_2
    const crateMarker_2 = new SmashableMarkerCrate(scene, 7616, -91);
    this.add(crateMarker_2);

    // platformLog_1
    const platformLog_1 = new PlatformMarkerJungleLog(scene, 7739, -240);
    this.add(platformLog_1);

    // gemMarker_1
    const gemMarker_1 = new SmallGemMarker(scene, 8302, -47);
    this.add(gemMarker_1);

    // gemMarker_6
    const gemMarker_6 = new SmallGemMarker(scene, 8076, -49);
    this.add(gemMarker_6);

    // decorationHelpSwitch_1
    const decorationHelpSwitch_1 = new DecorationHelpSwitch(scene, 6287, -321);
    this.add(decorationHelpSwitch_1);

    // decorationHelpSwitchDesk_1
    const decorationHelpSwitchDesk_1 = new DecorationHelpSwitchDesk(scene, 6372, -282);
    this.add(decorationHelpSwitchDesk_1);

    // decorationHelpSwitch_2
    const decorationHelpSwitch_2 = new DecorationHelpSwitch(scene, 7228, -321);
    this.add(decorationHelpSwitch_2);

    // decorationHelpSwitchDesk_2
    const decorationHelpSwitchDesk_2 = new DecorationHelpSwitchDesk(scene, 7313, -283);
    this.add(decorationHelpSwitchDesk_2);

    // gemMarker_7
    const gemMarker_7 = new SmallGemMarker(scene, 8542, -46);
    this.add(gemMarker_7);

    // decorationHelpJump_1
    const decorationHelpJump_1 = new DecorationHelpJump(scene, 2401, -321, 'game-all', "help-jump.png");
    this.add(decorationHelpJump_1);

    // decorationHelpJumpDesk_1
    const decorationHelpJumpDesk_1 = new DecorationHelpJumpDesk(scene, 2478, -273);
    this.add(decorationHelpJumpDesk_1);

    // decorationHelpJump_2
    const decorationHelpJump_2 = new DecorationHelpJump(scene, 3471, -321, 'game-all', "help-jump.png");
    this.add(decorationHelpJump_2);

    // decorationHelpJumpDesk_2
    const decorationHelpJumpDesk_2 = new DecorationHelpJumpDesk(scene, 3548, -273);
    this.add(decorationHelpJumpDesk_2);

    // checkpointMarker
    const checkpointMarker = new CheckpointMarker(scene, 8076, 29);
    this.add(checkpointMarker);

    // platformMarkerLogLong
    const platformMarkerLogLong = new PlatformMarkerJungleLogLong(scene, 2189, 50);
    this.add(platformMarkerLogLong);

    // decorationFloatingPoleLong
    const decorationFloatingPoleLong = new DecorationFloatingPoleLong(scene, 1911, 183);
    this.add(decorationFloatingPoleLong);

    // decorationFloatingPoleLong_1
    const decorationFloatingPoleLong_1 = new DecorationFloatingPoleLong(scene, 2222, 183);
    this.add(decorationFloatingPoleLong_1);

    // decorationFloatingPoleLong_2
    const decorationFloatingPoleLong_2 = new DecorationFloatingPoleLong(scene, 2494, 183);
    this.add(decorationFloatingPoleLong_2);

    // platformMarkerLogLong_7
    const platformMarkerLogLong_7 = new PlatformMarkerJungleLogLong(scene, 3312, 50);
    this.add(platformMarkerLogLong_7);

    // decorationFloatingPoleLong_21
    const decorationFloatingPoleLong_21 = new DecorationFloatingPoleLong(scene, 3034, 183);
    this.add(decorationFloatingPoleLong_21);

    // decorationFloatingPoleLong_22
    const decorationFloatingPoleLong_22 = new DecorationFloatingPoleLong(scene, 3345, 183);
    this.add(decorationFloatingPoleLong_22);

    // decorationFloatingPoleLong_23
    const decorationFloatingPoleLong_23 = new DecorationFloatingPoleLong(scene, 3617, 183);
    this.add(decorationFloatingPoleLong_23);

    // gemMarker
    const gemMarker = new SmallGemMarker(scene, 3899, -325);
    this.add(gemMarker);

    // gemMarker_5
    const gemMarker_5 = new SmallGemMarker(scene, 4059, -191);
    this.add(gemMarker_5);

    // this (components)
    const thisChunkBoundaries = new ChunkBoundaries(this);
    thisChunkBoundaries.leftBoundsMarker = editor_bounds_left;
    thisChunkBoundaries.rightBoundsMarker = editor_bounds_right;

    // crateMarker (components)
    const crateMarkerSimpleBreakableBlocker = SimpleBreakableBlocker.getComponent(crateMarker);
    crateMarkerSimpleBreakableBlocker.allowedCharacter = "panda";

    // decorationHelpSwitch (prefab fields)
    decorationHelpSwitch.zIndex = 200;
    decorationHelpSwitch.AnimateTime = 10000;

    // decorationHelpJump (prefab fields)
    decorationHelpJump.zIndex = 200;
    decorationHelpJump.AnimateTime = 3100;

    // decorationHelpJumpDesk (prefab fields)
    decorationHelpJumpDesk.zIndex = 200;
    decorationHelpJumpDesk.AnimateTime = 3100;

    // decorationHelpSwitchDesk (prefab fields)
    decorationHelpSwitchDesk.zIndex = 200;
    decorationHelpSwitchDesk.AnimateTime = 10000;

    // crateMarker_1 (components)
    const crateMarker_1SimpleBreakableBlocker = SimpleBreakableBlocker.getComponent(crateMarker_1);
    crateMarker_1SimpleBreakableBlocker.allowedCharacter = "ice";

    // crateMarker_2 (components)
    const crateMarker_2SimpleBreakableBlocker = SimpleBreakableBlocker.getComponent(crateMarker_2);
    crateMarker_2SimpleBreakableBlocker.allowedCharacter = "grizz";

    // decorationHelpSwitch_1 (prefab fields)
    decorationHelpSwitch_1.zIndex = 200;
    decorationHelpSwitch_1.AnimateTime = 12800;

    // decorationHelpSwitchDesk_1 (prefab fields)
    decorationHelpSwitchDesk_1.zIndex = 200;
    decorationHelpSwitchDesk_1.AnimateTime = 12800;

    // decorationHelpSwitch_2 (prefab fields)
    decorationHelpSwitch_2.zIndex = 200;
    decorationHelpSwitch_2.AnimateTime = 14500;

    // decorationHelpSwitchDesk_2 (prefab fields)
    decorationHelpSwitchDesk_2.zIndex = 200;
    decorationHelpSwitchDesk_2.AnimateTime = 14500;

    // decorationHelpJump_1 (prefab fields)
    decorationHelpJump_1.zIndex = 200;
    decorationHelpJump_1.AnimateTime = 5000;
    decorationHelpJump_1.PressTime = 400;

    // decorationHelpJumpDesk_1 (prefab fields)
    decorationHelpJumpDesk_1.zIndex = 200;
    decorationHelpJumpDesk_1.AnimateTime = 5000;
    decorationHelpJumpDesk_1.PressTime = 400;

    // decorationHelpJump_2 (prefab fields)
    decorationHelpJump_2.zIndex = 200;
    decorationHelpJump_2.AnimateTime = 6800;
    decorationHelpJump_2.PressTime = 1300;

    // decorationHelpJumpDesk_2 (prefab fields)
    decorationHelpJumpDesk_2.zIndex = 200;
    decorationHelpJumpDesk_2.AnimateTime = 6800;
    decorationHelpJumpDesk_2.PressTime = 1300;

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
